/* eslint-disable import/extensions */

import React from 'react';
import ReactDOM from 'react-dom';
import {
    createRoot
} from 'react-dom/client';

import MetricExplorer from '../components/MetricsExplorer.jsx';
import {
    QueryClient, QueryClientProvider
} from 'react-query';

const queryClient = new QueryClient();

RivalIQ.apps.MetricsExplorer.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {
    'use strict';

    const ComponentContainerView = RivalIQ.views.ItemView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        template: function () {
            return '<div class="react-container"></div>';
        },

        ui: {
            reactContainer: '.react-container'
        },

        dashboardModelEvents: {
            'change': 'render'
        },

        onRender: function () {
            const me = this;

            const landscapeId = me.getProp('landscapeId');
            const companyFilter = me.getProp('companySetDescriptor');
            const timePeriod = me.getProp('timePeriod');

            const element = (
                <QueryClientProvider client={queryClient}>
                    <MetricExplorer
                        substitutions={
                            {
                                companyFilter: companyFilter,
                                landscapeId: landscapeId,
                                timePeriod: timePeriod
                            }
                        }
                    />
                </QueryClientProvider>
            );

            if (!me.reactRoot) {
                me.reactRoot = createRoot(me.ui.reactContainer[0]);
            }
            me.reactRoot.render(element);
        },

        onDestroy: function () {
            const me = this;
            ReactDOM.unmountComponentAtNode(me.ui.reactContainer[0]);
        }
    });

    const MetricsExplorerWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: ComponentContainerView,
        hasFooter: _.constant(false),
        panelView: RivalIQ.apps.Dashboard.views.ChromelessPanel
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRICS_EXPLORER, MetricsExplorerWidget);
});
